export { BvlFormDatepickerComponent as BvlFormDatepicker } from './form-datepicker.component';
export { BvlFormDatepickerModule } from './form-datepicker.module';
